import React, { Component } from 'react'
import { connect } from 'react-redux'
import DarkRefreshIcon from '@/assets/images/icons/light/icon_refresh.png'
import RefreshIcon from '@/assets/images/icons/icon_refresh.png';
import '@/companys/ttl/assets/styles/components/market-detail-bottom-tab/market-detail-bottom-tab.scss'

import Warrants from '../DetailCenter/DetailPage/Warrants'
import HNews from '../DetailCenter/DetailPage/HNews'
import Options from '../DetailCenter/DetailPage/Options'
import {keyDownFunctions,accessibilityFunctions } from '@/helpers/functions';

class MarketBottomTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectTab: ['market_h_new', 'market_warrants',
            //  'market_position_proportion_Options'
            ],
            activeTab: 0
        }
    }

    render() {
        const { selectTab, activeTab } = this.state
        const { language,theme } = this.props
        return (
            <div className='market-detail-bottom-tab' >
                <div className='mdbt-head' >
                    <div className='select-tab' >
                        {selectTab.map((item, index) => {
                            return (
                                <div className='single-tab' key={item}
                                    onClick={() => this.handleSelectTab(index)}
                                    onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.handleSelectTab(index))}
                                    {...accessibilityFunctions.hasTabIndex()}
                                    style={{ color: activeTab == index ? '#1780C2' : '' }} >{language[item]}</div>
                            )
                        })}
                    </div>
                    <div className='refresh' onClick={() => this.refresh()} onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.refresh())} {...accessibilityFunctions.hasTabIndex()}><img src={ theme === 'light' ? DarkRefreshIcon : RefreshIcon} /></div>
                </div>
                <div className='mdbt-content'  >
                    {this.handleShowContent()}
                </div>
            </div>
        )
    }
    refresh = () => {
        switch (this.state.activeTab) {
            case 0:
                this.HNewsRef.refresh();
                break;
            case 1:
                this.WarrantsRef.getWarrants()
                break;
            case 2:
                this.OptionsRef.getData()
                break;
        }
    }
    handleSelectTab = (index) => {
        this.setState({ activeTab: index })
    }
    handleShowContent = () => {
        switch (this.state.activeTab) {
            case 0:
                return <HNews innerRef={e => this.HNewsRef = e} />
            case 1:
                return <Warrants quoteData={this.props.quoteData} innerRef={e => this.WarrantsRef = e} />
            case 2:
                return <Options innerRef={e => this.OptionsRef = e} />
        }
    }
}


export default connect((state) => ({
    language: state.app.language,
    theme:state.app.theme
}),
    dispatch => ({

    }))(MarketBottomTab)